import {  get } from "../../service/api";

const GetVatMerchants = async (merchantId,query) => {
    try {
        const response = await get(`/merchant/${merchantId}/vatMerchant?${query}`);
        return response;
    } catch (error) {
        console.error('Error GetVatMerchants:', error);
        throw error;
    }
};

export default GetVatMerchants;